import { Skeleton } from '@/components/ui/skeleton';

/**
 * Loading skeleton displayed while lazy-loaded route components are being fetched.
 * Mimics the typical page layout with header and content areas.
 *
 * Note it is only ever seen on a HARD page load — which is why it is kept: that
 * load has nothing else to show. The `<Suspense>` boundary that renders it sits
 * above `<Routes>` in App.tsx, so on an in-app navigation the boundary is already
 * mounted with content, and the transition around every navigation means React 18
 * keeps that content on screen rather than swapping in this fallback. An in-app
 * navigation is therefore covered by `RouteTransitionIndicator` instead, never by
 * this. See `tests/e2e/utils/route-commit.ts`.
 */
export function PageSkeleton() {
  return (
    <div data-testid="page-skeleton" className="flex flex-col h-full p-6 space-y-6">
      {/* Header skeleton */}
      <div className="flex items-center justify-between">
        <div className="space-y-2">
          <Skeleton className="h-8 w-48" />
          <Skeleton className="h-4 w-32" />
        </div>
        <Skeleton className="h-10 w-24" />
      </div>

      {/* Content skeleton */}
      <div className="flex-1 space-y-4">
        <Skeleton className="h-12 w-full" />
        <Skeleton className="h-64 w-full" />
        <Skeleton className="h-32 w-full" />
      </div>
    </div>
  );
}
